module.exports = require("nconf");


/*****************
 ** WEBPACK FOOTER
 ** external "nconf"
 ** module id = 10
 ** module chunks = 0
 **/